import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';

import {
  FormConfig,
  FormField,
  IFormComponent,
  IFormConfig,
  IFormField,
  IHasImage,
} from '@models/form/form';
import { IInputField, InputField } from '@models/form/input';

@Component({
  selector: 'app-form-file',
  templateUrl: './form-file.component.html',
  styleUrls: ['./form-file.component.scss'],
  // TODO: This is set to the default change detection for now to show validation messages correctly. Switch back when possible.
  changeDetection: ChangeDetectionStrategy.Default,
})
export class FormFileComponent
  implements IFormComponent<IInputField>, IHasImage
{
  public config: IFormField<IInputField> = new FormField<IInputField>({
    fieldConfig: new InputField(),
  });
  @Input() public currentImageFile: string = '';
  @Input() public formConfig: IFormConfig = new FormConfig();
  @Input() public group: UntypedFormGroup = new UntypedFormGroup({});

  public get formControl(): AbstractControl {
    return this.group.get(this.config.name);
  }
}
